module.exports = __webpack_public_path__ + "static/media/ImgReceptionEn.c628e8e0.svg";